import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isDisabled: false,
};

const localeSlice = createSlice({
  name: 'locale',
  initialState,
  reducers: {
    set({ isDisabled }, action) {
      return { ...action.payload, isDisabled };
    },
    toggle(state,) {
      return { ...state, isDisabled: !state.isDisabled };
    },
  },
});

export const locale = localeSlice.actions;
export default localeSlice.reducer;
